module.exports = __webpack_public_path__ + "1.5.0-unryo/img/memcached.f81fcfe6.png";